import React, { useEffect, useState } from "react";
import Head from "../../layout/head/Head";
import Content from "../../layout/content/Content";
import DatePicker from "react-datepicker";
import { orderData } from "../pre-built/orders/OrderData";
import axios from "axios";
import {useHistory, useParams} from 'react-router-dom';
import { API_URL } from "../../constent";

import {
  Block,
  BlockHeadContent,
  BlockTitle,
  BlockBetween,
  BlockHead,
  DataTableHead,
  DataTableItem,
  DataTableRow,
  Icon,
  TooltipComponent,
  PaginationComponent,
  PreviewAltCard,
  Row,
  Col,
  RSelect,
} from "../../components/Component";
import { getDateStructured } from "../../utils/Utils";
import { UncontrolledDropdown, DropdownMenu, DropdownToggle, DropdownItem, Button, Modal, ModalBody } from "reactstrap";
import { useForm } from "react-hook-form";
import { Link } from "react-router-dom/cjs/react-router-dom";

const Singlemainlist = () => {
  const [data, setData] = useState([]);
  const [smOption, setSmOption] = useState(false);
  const [loading, setLoading] = useState(false);
  const [getload, getLoading] = useState(false);
  const [formData, setFormData] = useState([]);
  const history = useHistory();
  const params = useParams()


  const [view, setView] = useState({
    add: false,
    details: false,
  });
  const [onSearchText, setSearchText] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [itemPerPage] = useState(7);
  const [userId, SetuserId] = useState("");

  // Changing state value when searching name

  useEffect(() => {

    var userData = JSON.parse(localStorage.getItem('userData'));

    console.log(userData);
    
    SetuserId(userData[0]['id']);

  },[]);

  useEffect(() => {
    if (onSearchText !== "") {
      const filteredObject = data.filter((item) => {
        // return item.fullname.includes(onSearchText);
        return item.fullname.toLowerCase().includes(onSearchText.toLowerCase())
      });
      setData(filteredObject);
    } else {

        
        var userData = JSON.parse(localStorage.getItem('userData'));
        var getuserid = userData?.[0]?.id;
        var category_id = params.id
        var renl_type = params.type

        axios.get(`${API_URL}getsinglemainsheet/${getuserid}/${category_id}/${renl_type}`).then((result)=>
        {
            console.log(result.data);
            setData(result.data);
            getLoading(false);
        })
    }
  }, [onSearchText]);


  if (getload) {
    return(
       <>
         <p>Loading....</p>
       </>
    ) 
} 


  // toggle function to view order details
  const toggle = (type) => {
    setView({
      add: type === "add" ? true : false,
      details: type === "details" ? true : false,
    });
  };

  // selects all the order
  const selectorCheck = (e) => {
    let newData;
    newData = data.map((item) => {
      item.check = e.currentTarget.checked;
      return item;
    });
    setData([...newData]);
  };

  // selects one order
  const onSelectChange = (e, id) => {
    let newData = data;
    let index = newData.findIndex((item) => item.id === id);
    newData[index].check = e.currentTarget.checked;
    setData([...newData]);
  };

 
  // function to load detail data
  const loadDetail = (id) => {
    let index = data.findIndex((item) => item.id === id);
    setFormData(data[index]);
  };

  // OnChange function to get the input data
  const onInputChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  // onChange function for searching name
  const onFilterChange = (e) => {
    setSearchText(e.target.value);
  };

  // function to close the form modal
  const onFormCancel = () => {
    setView({ add: false, details: false });
  };

  // function to change to approve property for an item
  const markAsDelivered = (id) => {
    let newData = data;
    let index = newData.findIndex((item) => item.id === id);
    newData[index].status = "Delivered";
    setData([...newData]);
  };

  // function to delete a Order
  const deleteOrder = (id) => {
    let defaultData = data;
    defaultData = defaultData.filter((item) => item.id !== id);
    setData([...defaultData]);
  };

  // function to delete the seletected item
  const selectorDeleteOrder = () => {
    let newData;
    newData = data.filter((item) => item.check !== true);
    setData([...newData]);
  };

  // function to change the complete property of an item
  const selectorMarkAsDelivered = () => {
    let newData;
    newData = data.map((item) => {
      if (item.check === true) item.status = "Delivered";
      return item;
    });
    setData([...newData]);
  };

  // Get current list, pagination
  const indexOfLastItem = currentPage * itemPerPage;
  const indexOfFirstItem = indexOfLastItem - itemPerPage;
  const currentItems = data.slice(indexOfFirstItem, indexOfLastItem);

  
  return (
    <React.Fragment>
      <Head title="Main List<"></Head>
      <Content>
        <BlockHead size="sm">
          <BlockBetween>
            <BlockHeadContent>
              <BlockTitle>{params.type == 1 ? "Renewal" : "New business" } List</BlockTitle>
            </BlockHeadContent>
            <BlockHeadContent>
              <div className="toggle-wrap nk-block-tools-toggle">
                <a
                  href="#more"
                  className="btn btn-icon btn-trigger toggle-expand mr-n1"
                  onClick={(ev) => {
                    ev.preventDefault();
                    setSmOption(!smOption);
                  }}
                >
                  <Icon name="more-v"></Icon>
                </a>
                <div className="toggle-expand-content" style={{ display: smOption ? "block" : "none" }}>
                  <ul className="nk-block-tools g-3">
                    <li>
                      <div className="form-control-wrap">
                        <div className="form-icon form-icon-right">
                          <Icon name="search"></Icon>
                        </div>
                        <input
                          type="text"
                          className="form-control"
                          id="default-04"
                          placeholder="Search by User Name"
                          onChange={(e) => onFilterChange(e)}
                        />
                      </div>
                    </li>
                    <li>
                        <Link to="/main-sheet" className="btn btn-info"><Icon name="plus"></Icon> <span>Add Main List</span></Link>
                    </li>
                  </ul>
                </div>
              </div>
            </BlockHeadContent>
          </BlockBetween>
        </BlockHead>

        <Block>
        <div className="card">
        <div className="table-responsive card-inner">
                <table className="table table-bordered table-striped">
                    <thead>
                    <tr>
                        <th>
                        <input
                            type="checkbox"
                            id="select-all"
                            onChange={(e) => selectorCheck(e)}
                        />
                        </th>
                        <th>Proposer</th>
                        <th>Email</th>
                        <th>Contact Number</th>
                        <th>Type of Policy</th>
                        <th>Category</th>
                        <th>Registration No.</th>
                        <th>Stage</th>
                        <th>Date of Expiry</th>
                        <th>Agent</th>
                        <th>Premium</th>
                        <th>Income Premium</th>
                        <th>Sum Insured</th>

                        <th>STATUS OF RENEWAL</th>
                        <th>PREVIOUS POLICY NUMBER</th>
                        <th>PREVIOUS COMPANY</th>
                        <th>CURRENT POLICY NUMBER</th>
                        <th>CURRENT COMPANY</th>

                        <th>PAYMENT BY</th>
                        <th>PAYMENT RECEIVED STATUS</th>
                        <th>DETAILS OF PAYMENT</th>
                        <th>CHEQUE DATE</th>
                        <th>CHEQUE AMOUNT</th>
                        <th>MODE OF PAYMENT</th>
                        <th>PAYMENT DETAILS</th>
                        <th>Action</th>
                    </tr>
                    </thead>
                    <tbody>
                    {currentItems.length > 0
                        ? currentItems.map((item) => (
                            <tr key={item.id}>
                            <td>
                                <input
                                type="checkbox"
                                defaultChecked={item.check}
                                id={item.id + "checkbox"}
                                onChange={(e) => onSelectChange(e, item.id)}
                                />
                            </td>
                            <td>
                                <a href="#id" onClick={(ev) => ev.preventDefault()}>
                                {item.prop_name}
                                </a>
                            </td>
                            <td>{item.prop_email}</td>
                            <td>{item.prop_phone}</td>
                            <td>{item.policy_name}</td>
                            <td>{item.category_name}</td>
                            <td>{item.registration}</td>
                            <td>{item.stage_name}</td>
                            <td>{item.date_of_expiry}</td>
                            <td>{item.agent_name}</td>
                            <td>{item.premium}</td>
                            <td>{item.incomepremium}</td>
                            <td>{item.insured}</td>
                            <td>{item.renewal_status === '1' ? (
                                <div>RENEWAL</div>
                                ) : item.renewal_status === '2' ? (
                                <div>ROLLOVER</div>
                                ) : (
                                <div>PORTABILITY</div>
                                )}</td>
                            <td>{item.pre_policy}</td>
                            <td>{item.pre_company}</td>
                            <td>{item.cur_policy}</td>
                            <td>{item.cur_company}</td>
                            <td>{item.payment_by === 1 ? (
                                <div>CUSTOMER</div>
                                ) : item.renewal_status === 2 ? (
                                <div>AGENT</div>
                                ) : (
                                <div></div>
                                )}</td>
                            <td>{item.recived_status}</td>
                            <td></td>
                            <td>{item.cheque_date}</td>
                            <td>{item.cheque_amount}</td>
                            <td>{item.mode_of_payment === 1 ? (
                                <div>ONLINE</div>
                                ) : item.mode_of_payment === 2 ? (
                                <div>CHEQUE</div>
                                ) : (
                                <div></div>
                                )}</td>

                            <td>{item.payment_details}</td>
                            <td>
                                <button
                                className="btn btn-sm btn-danger"
                                onClick={() => deleteOrder(item.id)}
                                >
                                Delete
                                </button>
                            </td>
                            </tr>
                        ))
                        : (
                        <tr>
                            <td colSpan="13" className="text-center">
                            No data available
                            </td>
                        </tr>
                        )}
                    </tbody>
                </table>
                </div>
            </div>
        </Block>

      </Content>
    </React.Fragment>
  );
};

export default Singlemainlist;
